"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _LatestCss = _interopRequireDefault(require("./Latest.css.js"));

var _radium = _interopRequireDefault(require("radium"));

var _feedToolz = require("../feed-toolz");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LatestArticle = function LatestArticle(_ref) {
  var key = _ref.key,
      article = _ref.article,
      styleVariants = _ref.styleVariants;
  var title = article.title,
      categories = article.categories,
      link = article.link,
      content = article.content,
      html = article.html;

  var handleLinkClick = function handleLinkClick(e) {
    e.preventDefault();
    window.open(link, '_blank');
  };

  var fullArticleTitleStyle = Object.assign({}, _LatestCss.default['articleTitle'], styleVariants['articleTitle']);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: key,
    style: _LatestCss.default.articleRow,
    onClick: handleLinkClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _LatestCss.default.titleColumn
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: fullArticleTitleStyle
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    style: _LatestCss.default.keywordContainer
  }, categories.map(function (category, j) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: _LatestCss.default.keyword,
      key: "".concat(title, "-category-item-").concat(j)
    }, /*#__PURE__*/_react.default.createElement("a", {
      key: "category-link-".concat(j),
      style: _LatestCss.default.category,
      href: link
    }, /*#__PURE__*/_react.default.createElement("span", null, category)));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: _LatestCss.default.textColumn
  }, (0, _feedToolz.trimSnippet)(content)), /*#__PURE__*/_react.default.createElement("div", {
    style: _LatestCss.default.imageColumn
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({}, _LatestCss.default.imageComponent, {
      backgroundImage: "url(".concat((0, _feedToolz.getSrcFromHtml)(html), ")")
    })
  })));
};

var _default = (0, _radium.default)(LatestArticle);

exports.default = _default;

//# sourceMappingURL=LatestArticle.jsx.map